/**
 * Names the deadline of a product's "add", so it can be canceled once the
 * product reports back.
 */
export function getAddTimeoutId(selectionId: string) {
  return `add-timeout-${selectionId}`;
}
